module.exports = __webpack_public_path__ + "static/media/park-map.dbca5030.jpg";